import React from "react";
import { Modal, Box, Typography } from "@mui/material";

const ModalComp = ({
  open,
  handleClose,
  title,
  fields,
  themeStyles,
  modelButtons,
  modalContent,
  setCustomOpenModal,
}) => {
  return (
    <Modal
      open={open}
      setCustomOpenModal={setCustomOpenModal}
      onClose={handleClose}
    >
      <Box
        sx={{
          ...themeStyles?.boxStyle,
          backgroundColor: "white",
          borderRadius: "0px",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            backgroundColor: "#F4F4F4",
            color: "#000",
            ...themeStyles?.titleStyle,
          }}
        >
          {title}
        </Typography>

        <Box sx={{ 
           ...themeStyles?.modalContentStyle,
          padding: "36px 24px 24px 24px", overflowY: "auto" }}>{modalContent}</Box>

        <Box
          sx={{
            ...themeStyles?.actionButtonContainerStyle,
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: themeStyles?.actionButtonContainerStyle?.padding || "20px",
          }}
        >
          {modelButtons}
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalComp;
